import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import {
  useExitPreviewMode,
  useHasExitedPreviewMode,
  useIsOrgScopedPreviewMode,
  usePreviewProgramNames,
} from 'bundles/unified-common/contexts/org-scoped/OrgScopedImpersonationContext';
import OrgScopedAdminImpersonationBanner from 'bundles/unified-home-common/components/org-scoped/OrgScopedAdminImpersonationBanner';

const OrgScopedAdminImpersonationBannerRenderer = () => {
  const isPreviewMode = useIsOrgScopedPreviewMode();
  const programNames = usePreviewProgramNames();
  const exitPreviewMode = useExitPreviewMode();
  // The "exited" flag lives in context (not local state) so every exit path —
  // the banner's "Exit preview" button and the change-programs modal applying
  // an empty selection — shows the same exited banner state. It also keeps the
  // banner visible after the Apollo refetch flips isPreviewMode to false.
  const hasExitedPreviewMode = useHasExitedPreviewMode();

  if ((!isPreviewMode && !hasExitedPreviewMode) || !isAuthenticatedUser()) return null;

  return (
    <OrgScopedAdminImpersonationBanner
      programNames={programNames}
      exitedPreviewMode={hasExitedPreviewMode}
      onExitPreviewMode={() => exitPreviewMode?.()}
    />
  );
};

export default OrgScopedAdminImpersonationBannerRenderer;
